import { RouteConfig } from 'vue-router';
import * as handlers from '../handlers';

const routes: Array<RouteConfig> = [
  {
    path: '1',
    name: 'bli-policies-1',
    component: () => import('@/pages/quote/forms/liability/pages/LiabilityPageGlSlEl.vue'),
    meta: {
      back: handlers.dashboard
    }
  },
  {
    path: '2',
    name: 'bli-policies-2',
    component: () => import('@/pages/quote/forms/liability/pages/LiabilityPageDoEdCrimeLpdc.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'bli-policies-1', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
  {
    path: '3',
    name: 'bli-specified-activities',
    component: () => import('@/pages/quote/forms/liability/pages/LiabilityPageSpecifiedActivities.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'bli-policies-2', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
  {
    path: '4',
    name: 'bli-claims',
    component: () => import('@/pages/quote/forms/liability/pages/LiabilityPageClaims.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'bli-specified-activities', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
  {
    path: '5',
    name: 'bli-client-events',
    component: () => import('@/pages/quote/forms/general/ClientEventsPage.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'bli-claims', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
];

export default routes;
